import React from "react";
import {Container, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ListItem from '@material-ui/core/ListItem';
import {MateriasDownloadable} from "../Source/MateriasDownloadable";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import blueGrey from "@material-ui/core/colors/blueGrey";

const useStyles = makeStyles((theme) => ({
    root: {
        // width: '80%',
        // padding: '50px 50px',
        color: blueGrey[800],
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: '500',
    },
    accordionHeader: {
        fontWeight: theme.typography.fontWeightMedium
    },
    titleWithBackgroundImage: {
        background: `url("https://sim4r4-public.s3.amazonaws.com/enfermeriauvt-source/Images/Books.jpg")`,
        backgroundSize: '100%',
        opacity: '.85',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '70px',
        color: 'white',
        height: '20rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

export default function Apoyo(props) {
    const classes = useStyles();

    function redirectTo(url) {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null;
    }

    return (
        <Container className={classes.root}>
            <div className={classes.titleWithBackgroundImage}>
                <Typography variant="h2" gutterBottom>
                    Material de Apoyo
                </Typography>
                <Typography variant="h3" gutterBottom>
                    <span>
                        Licenciatura en Administración
                    </span> <br/>
                    <span>
                        de Empresas
                    </span>
                </Typography>

            </div>
            <div style={{padding: "50px 0"}}>
                <List component="nav" aria-label="main mailbox folders">
                    {MateriasDownloadable.map(o => {
                        return (
                            <ListItem button onClick={() => redirectTo(o.url)}>
                                <ListItemIcon>
                                    {o.icon}
                                </ListItemIcon>
                                <ListItemText primary={o.title} secondary={o.author}/>
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        </Container>
    );
}

